goog.provide("shadow.js.shim.module$$mui$material$TableBody");
goog.provide("module$shadow_js_shim_module$$mui$material$TableBody");
shadow.js.shim.module$$mui$material$TableBody = shadow.js.nativeProvides["@mui/material/TableBody"] = shadow$bridge("@mui/material/TableBody");
module$shadow_js_shim_module$$mui$material$TableBody.default = shadow.js.shim.module$$mui$material$TableBody;
